// Comprehensive data repository based on docs/new/new-sbb.md specification brief

export const categories = [
  {
    id: 'gedung-bertingkat',
    slug: 'gedung-bertingkat',
    name: 'Gedung Bertingkat',
    name_en: 'High-Rise Buildings',
    type: 'solution',
    description: 'Solusi beton kekuatan tinggi dan pompa jarak jauh khusus untuk struktur gedung tinggi, pencakar langit, dan basement dalam.',
    image: '/reference-images/high-rise.webp',
    challenges: 'Memerlukan kemudahan pemompaan hingga ketinggian ekstrim, hidrasi teruji untuk elemen tebal (mass concrete), serta workability tahan lama.',
  },
  {
    id: 'bangunan-komersial',
    slug: 'bangunan-komersial',
    name: 'Bangunan Komersial',
    name_en: 'Commercial Buildings',
    type: 'solution',
    description: 'Bahan bangunan beton berperforma tinggi untuk mal, pusat perbelanjaan, hotel, dan kawasan bisnis dengan estetika tinggi.',
    image: '/reference-images/commercial.webp',
    challenges: 'Jadwal konstruksi cepat, kebutuhan lantai bebas retak, finishing halus, serta integrasi beton dekoratif.',
  },
  {
    id: 'infrastruktur',
    slug: 'infrastruktur',
    name: 'Infrastruktur',
    name_en: 'Infrastructure',
    type: 'solution',
    description: 'Beton daya tahan tinggi untuk jalan tol, jembatan, bandara, pelabuhan, dan bendungan dengan ketahanan asam & sulfat.',
    image: '/reference-images/infrastructure.webp',
    challenges: 'Beban lalu lintas berat, paparan lingkungan agresif (laut & sulfat), serta spesifikasi umur pakai 50+ tahun.',
  },
  {
    id: 'industri',
    slug: 'industri',
    name: 'Industri',
    name_en: 'Industrial Facilities',
    type: 'solution',
    description: 'Solusi lantai industri presisi tinggi, struktur pabrik, gudang logistik, dan fasilitas manufaktur.',
    image: '/reference-images/industry.webp',
    challenges: 'Ketahanan gesek mekanis (abrasion resistance), beban statis heavy-duty forklift, dan kelataan lantai flatness (F-numbers).',
  },
  {
    id: 'rumah-tinggal',
    slug: 'rumah-tinggal',
    name: 'Rumah Tinggal',
    name_en: 'Residential Housing',
    type: 'solution',
    description: 'Pilihan beton siap pakai yang efisien, praktis, dan ramah lingkungan untuk perumahan, klaster, dan rumah tinggal.',
    image: '/reference-images/residential.webp',
    challenges: 'Akses jalan sempit di area pemukiman, volume pemesanan fleksibel, dan kecepatan pengerjaan tanpa mengganggu tetangga.',
  },
  {
    id: 'solusi-teraplikasi',
    slug: 'solusi-teraplikasi',
    name: 'Solusi Teraplikasi',
    name_en: 'Applied Solutions',
    type: 'solution',
    description: 'Produk beton rekayasa khusus dengan fitur perbaikan cepat, beton berpori menyerap air, hingga beton perkerasan khusus.',
    image: '/reference-images/applied-solutions.webp',
    challenges: 'Kebutuhan solusi khusus seperti drainase alami, perbaikan jalan overnight (8 jam), atau dekoratif lansekap.',
  },
  {
    id: 'agregat',
    slug: 'agregat',
    name: 'Agregat & Material',
    name_en: 'Aggregates & Materials',
    type: 'material',
    description: 'Batu pecah (crushed stone), pasir kuarsa, dan agregat berkualitas tinggi dari tambang resmi milik Solusi Bangun Beton.',
    image: '/reference-images/aggregates.webp',
    challenges: 'Konsistensi gradasi batuan, kebersihan dari kadar lumpur, dan jaminan pasokan skala besar tepat waktu.',
  }
];

export const products = [
  // Ready-Mix
  {
    id: 'pakcrete',
    slug: 'pakcrete',
    name: 'PakCrete™',
    category: 'ready-mix',
    categoryName: 'Ready-Mix Concrete',
    tagline: 'Beton struktural performa tinggi dalam kemasan siap guna',
    summary: 'Formulasi beton presisi tinggi yang menjamin mutu dan fleksibilitas untuk struktur bangunan bertingkat dan komersial.',
    image: '/reference-images/ready-mix.webp',
    benefits: [
      'Mutu beton terjamin dan konsisten dari batching plant modern',
      'Memudahkan pengerjaan pengecoran dengan pemompaan lancar',
      'Mengurangi biaya tenaga kerja dan risiko segregasi material',
      'Ramah lingkungan dengan penggunaan semen blended SIG'
    ],
    applications: ['Kolom & Balok Gedung', 'Pelat Lantai Basement', 'Dinding Geser (Shear Wall)', 'Pondasi Bore Pile'],
    specs: { strength: 'K-225 s/d K-600 (FC 20 - FC 50 MPa)', slump: '12 ± 2 cm s/d 18 ± 2 cm', aggregateSize: '20 mm max' },
    brochureUrl: '#pdf-download-pakcrete'
  },
  {
    id: 'ready-mix-standard',
    slug: 'ready-mix-standard',
    name: 'Ready-Mix Standard',
    category: 'ready-mix',
    categoryName: 'Ready-Mix Concrete',
    tagline: 'Beton siap pakai standar industri untuk segala kebutuhan proyek',
    summary: 'Pilihan utama para kontraktor nasional untuk pengecoran lantai, jalan, pondasi, dan struktur bangunan umum.',
    image: '/reference-images/ready-mix.webp',
    benefits: [
      'Ketersediaan luas dari 30+ batching plant di Indonesia',
      'Harga kompetitif dengan dukungan armada mixer terkalibrasi',
      'Pengawasan kualitas laboratorium terakreditasi'
    ],
    applications: ['Perumahan & Ruko', 'Jalan Komprehensif', 'Pondasi Rumah', 'Lantai Gudang'],
    specs: { strength: 'K-100 s/d K-500', slump: '10 ± 2 cm s/d 14 ± 2 cm', aggregateSize: '20 mm' },
    brochureUrl: '#pdf-download-readymix'
  },
  {
    id: 'minimix',
    slug: 'minimix',
    name: 'MiniMix',
    category: 'ready-mix',
    categoryName: 'Ready-Mix Concrete',
    tagline: 'Armada beton kecil untuk lokasi jalan sempit dan pemukiman',
    summary: 'Solusi pengecoran dengan truk molen berukuran kecil (kapasitas 2-3 m³) yang mampu menjangkau lorong sempit tanpa merusak jalan.',
    image: '/reference-images/ready-mix.webp',
    benefits: [
      'Dapat melewati jalan lingkungan dengan lebar mulai 2.5 meter',
      'Beban kendaraan lebih ringan, tidak merusak perkerasan lokal',
      'Mutu setara dengan beton truk besar'
    ],
    applications: ['Renovasi Rumah Tinggal', 'Gang & Jalan Lingkungan', 'Area Garasi & Carport', 'Pondasi Klaster'],
    specs: { strength: 'K-175 s/d K-350', slump: '12 ± 2 cm', aggregateSize: '20 mm' },
    brochureUrl: '#pdf-download-minimix'
  },

  // Solusi Teraplikasi
  {
    id: 'speedcrete',
    slug: 'speedcrete',
    name: 'SpeedCrete™',
    category: 'solusi-teraplikasi',
    categoryName: 'Solusi Teraplikasi',
    tagline: 'Perbaikan perkerasan beton super cepat, open-traffic 4–8 jam',
    summary: 'Inovasi beton cepat kering yang memungkinkan perbaikan jalan dan runway bandara dilakukan pada malam hari dan langsung dibuka untuk lalu lintas pada pagi hari.',
    image: '/reference-images/applied-solutions.webp',
    benefits: [
      'Mencapai kekuatan struktural (FC 30 MPa) hanya dalam 4-8 jam',
      'Mencegah kemacetan parah akibat penutupan jalan lama',
      'Durabilitas tinggi terhadap gesekan beban kendaraan berat'
    ],
    applications: ['Jalan Tol & Utama', 'Runway & Taxiway Bandara', 'Area Perlintasan Kereta Api', 'Lantai Docking Gudang'],
    specs: { strength: 'Flexural Strength 4.5 MPa @ 8 jam', slump: '15 ± 2 cm', aggregateSize: '20 mm' },
    brochureUrl: '#pdf-download-speedcrete'
  },
  {
    id: 'thrucrete',
    slug: 'thrucrete',
    name: 'ThruCrete™',
    category: 'solusi-teraplikasi',
    categoryName: 'Solusi Teraplikasi',
    tagline: 'Beton porus ramah lingkungan penyerap air hujan ke dalam tanah',
    summary: 'Beton berpori yang mampu melewatkan air hingga 500 liter/m²/menit langsung ke tanah pendukung untuk mencegah banjir dan genangan air.',
    image: '/reference-images/project-gbk.webp',
    benefits: [
      'Menghilangkan genangan air secara instan',
      'Membantu konservasi air tanah alami (Eco-Friendly)',
      'Mengurangi efek panas perkotaan (Urban Heat Island)'
    ],
    applications: ['Trotoar & Pedestrian', 'Area Parkir Terbuka', 'Jalan Taman & Alun-alun', 'Lapangan Olahraga'],
    specs: { permeability: '> 500 L/m²/min', strength: 'K-200 / K-250', voidContent: '15% - 25%' },
    brochureUrl: '#pdf-download-thrucrete'
  },
  {
    id: 'apexcrete',
    slug: 'apexcrete',
    name: 'ApexCrete™',
    category: 'solusi-teraplikasi',
    categoryName: 'Solusi Teraplikasi',
    tagline: 'Lantai beton ekstra rata dan bebas retak untuk industri tinggi',
    summary: 'Didesain khusus untuk lantai industri dengan persyaratan tingkat kelataan tinggi (Super Flat Floor) menggunakan teknologi laser screed.',
    image: '/reference-images/industry.webp',
    benefits: [
      'Memenuhi standar kelataan F-Numbers (FF/FL) dunia',
      'Ketahanan luar biasa terhadap abrasi mekanis forklift',
      'Menghindari biaya pemeliharaan lantai berulang'
    ],
    applications: ['Gudang Otomatis (VNA Warehouse)', 'Pabrik Farmasi & Elektronik', 'Pusat Distribusi Logistik'],
    specs: { strength: 'FC 35 - FC 50 MPa', slump: '14 ± 2 cm', abrasion: 'EN 13892-4 AR 0.5' },
    brochureUrl: '#pdf-download-apexcrete'
  },
  {
    id: 'dekocrete',
    slug: 'dekocrete',
    name: 'DekoCrete™',
    category: 'solusi-teraplikasi',
    categoryName: 'Solusi Teraplikasi',
    tagline: 'Beton artistik dekoratif untuk estetika lanskap luar dan dalam ruangan',
    summary: 'Kombinasi kekuatan beton dengan tekstur batuan exposed aggregate atau pola stempel warna yang estetis untuk ruang publik modern.',
    image: '/reference-images/applied-solutions.webp',
    benefits: [
      'Pilihan warna dan tekstur alami tidak mudah pudar',
      'Permukaan anti-slip aman untuk pejalan kaki',
      'Tahan lama tanpa perlu penggantian paving berulang'
    ],
    applications: ['Plaza Komersial & Pedestrian', 'Area Kolam Renang', 'Taman Kota & Alun-Alun', 'Lobi Hotel'],
    specs: { strength: 'K-250 s/d K-350', texture: 'Exposed Aggregate / Stamped Pattern' },
    brochureUrl: '#pdf-download-dekocrete'
  },
  {
    id: 'ezyflocrete',
    slug: 'ezyflocrete',
    name: 'EzyfloCrete™',
    category: 'solusi-teraplikasi',
    categoryName: 'Solusi Teraplikasi',
    tagline: 'Beton mandiri padat (Self-Consolidating Concrete / SCC)',
    summary: 'Beton yang dapat mengalir dan memadat sendiri tanpa memerlukan penggetar (vibrator), ideal untuk struktur rapat pembesian.',
    image: '/reference-images/applied-solutions.webp',
    benefits: [
      'Mengisi seluruh rongga tulangan rapat tanpa keropos (honeycomb)',
      'Mengurangi kebisingan pekerjaan di area pemukiman (tanpa vibrator)',
      'Permukaan beton sangat halus bebas cacat'
    ],
    applications: ['Elemen Precast Khusus', 'Dinding Beton Arsitektural', 'Kolom Padat Tulangan'],
    specs: { slumpFlow: '650 - 750 mm', strength: 'FC 35 - FC 60 MPa' },
    brochureUrl: '#pdf-download-ezyflocrete'
  },

  // Agregat
  {
    id: 'agregat-kasar',
    slug: 'agregat-kasar',
    name: 'Agregat Kasar (Split / Crushed Stone)',
    category: 'agregat',
    categoryName: 'Agregat & Material',
    tagline: 'Batu pecah batuan andesit & basalt murni dari tambang bersertifikat',
    summary: 'Diproses dari batuan keras berkualitas tinggi dengan berbagai ukuran gradasi untuk bahan baku beton dan perkerasan jalan.',
    image: '/reference-images/aggregates.webp',
    benefits: [
      'Bentuk kubikal (cubical shape) mengurangi kehausan semen',
      'Tingkat kekerasan Los Angeles Abrasion < 20%',
      'Bebas dari kandungan bahan organik dan lempung'
    ],
    applications: ['Bahan Utama Ready-Mix', 'Ballast Kereta Api', 'Lapis Pondasi Jalan (Base Course A/B)'],
    specs: { sizes: '10-20 mm, 20-30 mm, Screenings 0-5 mm', abrasion: '< 20%' },
    brochureUrl: '#pdf-download-agregat'
  },
  {
    id: 'agregat-halus',
    slug: 'agregat-halus',
    name: 'Agregat Halus (Pasir Cuci & Manufacture Sand)',
    category: 'agregat',
    categoryName: 'Agregat & Material',
    tagline: 'Pasir olahan pabrik dengan tingkat kebersihan dan gradasi sempurna',
    summary: 'Material agregat halus hasil pemecahan batuan yang dicuci bersih dari kadar lumpur untuk menjamin kekuatan beton maksimal.',
    image: '/reference-images/aggregates.webp',
    benefits: [
      'Kadar lumpur < 2% menjamin daya rekat semen sempurna',
      'Gradasi konsisten meningkatkan workability adukan',
      'Pasokan stabil tanpa tergantung musim pasang surut sungai'
    ],
    applications: ['Beton Struktural Mutu Tinggi', 'Mortar Presisi', 'Precast Concrete Components'],
    specs: { finenessModulus: '2.3 - 3.1', clayContent: '< 2%' },
    brochureUrl: '#pdf-download-pasir'
  }
];

export const projects = [
  {
    id: 'proyek-jalan-tol-cisumdawu',
    slug: 'jalan-tol-cisumdawu',
    name: 'Jalan Tol Cileunyi – Sumedang – Dawuan (Cisumdawu)',
    client: 'Kementerian PUPR & PT CKJT',
    contractor: 'BUMN Karya & Consortia',
    location: 'Jawa Barat',
    year: '2021 – 2023',
    category: 'infrastruktur',
    categoryName: 'Infrastruktur',
    image: '/reference-images/project-cisumdawu.webp',
    summary: 'Pasokan beton struktural mutu tinggi dan perkerasan kaku (rigid pavement) untuk proyek tol strategis nasional terowongan terpanjang di Indonesia.',
    challenge: 'Kondisi topografi berbukit dengan risiko longsor, kebutuhan pengecoran terowongan (twin tunnel) berdiameter besar, serta suhu beton yang harus dikontrol ketat.',
    solution: 'Solusi Bangun Beton mendirikan 3 dedicated mobile batching plant di sepanjang jalur tol, menyuplai beton temperatur terkontrol (chilled concrete) dan PakCrete™.',
    usedProducts: ['PakCrete™', 'Ready-Mix Standard', 'SpeedCrete™'],
    gallery: [
      '/reference-images/project-cisumdawu.webp',
      '/reference-images/infrastructure.webp'
    ]
  },
  {
    id: 'proyek-stasiun-lrt-jabodebek',
    slug: 'stasiun-lrt-jabodebek',
    name: 'Stasiun & Jalur Layang LRT Jabodebek',
    client: 'PT Adhi Karya (Persero) Tbk',
    contractor: 'PT Adhi Karya',
    location: 'DKI Jakarta & Jawa Barat',
    year: '2019 – 2022',
    category: 'infrastruktur',
    categoryName: 'Infrastruktur',
    image: '/reference-images/project-terminal.webp',
    summary: 'Penyediaan beton pracetak dan beton cair struktural presisi untuk tiang pancang (pier head) dan concourse LRT Jabodebek.',
    challenge: 'Pengecoran malam hari di jalur arteri padat lalu lintas Jakarta tanpa mengganggu aktivitas moda transportasi lain.',
    solution: 'Penggunaan armada MiniMix dan penuangan tepat waktu dengan integrasi GPS koordinat dari plant Pulogadung dan Serpong.',
    usedProducts: ['PakCrete™', 'MiniMix', 'EzyfloCrete™'],
    gallery: [
      '/reference-images/project-terminal.webp'
    ]
  },
  {
    id: 'proyek-menara-bca-cbd',
    slug: 'menara-bca-cbd',
    name: 'Menara Komersial Sudirman Central Business',
    client: 'Swasta / Konsorsium',
    contractor: 'Total Bangun Persada',
    location: 'Jakarta Selatan',
    year: '2022 – 2024',
    category: 'gedung-bertingkat',
    categoryName: 'Gedung Bertingkat',
    image: '/reference-images/project-lotte.webp',
    summary: 'Pembangunan 55 lantai menara perkantoran dengan beton kekuatan ultra tinggi FC 60 MPa untuk elemen kolom struktural.',
    challenge: 'Pemompaan beton hingga ketinggian di atas 200 meter secara kontinu tanpa penyumbatan pipa (pipe clogging).',
    solution: 'Aplikasi khusus PakCrete™ High Slump Retaining dengan campuran agen pengurang air tingkat tinggi (superplasticizer).',
    usedProducts: ['PakCrete™', 'EzyfloCrete™'],
    gallery: [
      '/reference-images/project-lotte.webp'
    ]
  },
  {
    id: 'proyek-gudang-logistik-cikarang',
    slug: 'gudang-logistik-cikarang',
    name: 'Mega Warehouse Logistics Park Cikarang',
    client: 'Global Logistics Property',
    contractor: 'PT Wijaya Karya Bangunan Gedung',
    location: 'Cikarang, Jawa Barat',
    year: '2023',
    category: 'industri',
    categoryName: 'Industri',
    image: '/reference-images/industry.webp',
    summary: 'Konstruksi lantai gudang bebas retak seluas 80.000 m² yang dirancang menahan beban rak tinggi dan lalu lintas forklift 24 jam.',
    challenge: 'Syarat ketat kelataan lantai (Superflat Class F-75) untuk pengoperasian sistem pemilah otomatis robotik.',
    solution: 'Pengaplikasian beton lantai ApexCrete™ dikombinasikan dengan teknik pemadatan laser screed.',
    usedProducts: ['ApexCrete™', 'Agregat Kasar'],
    gallery: [
      '/reference-images/industry.webp'
    ]
  },
  {
    id: 'proyek-revitalisasi-pedestrian-sudirman',
    slug: 'pedestrian-sudirman',
    name: 'Revitalisasi Trotoar & Plaza Pedestrian Sudirman',
    client: 'Dinas Bina Marga DKI Jakarta',
    contractor: 'PT Jaya Konstruksi',
    location: 'Jakarta Pusat',
    year: '2022',
    category: 'solusi-teraplikasi',
    categoryName: 'Solusi Teraplikasi',
    image: '/reference-images/project-gbk.webp',
    summary: 'Penerapan beton berpori ThruCrete™ dan beton dekoratif DekoCrete™ untuk mewujudkan fasilitas pedestrian kelas dunia yang ramah lingkungan.',
    challenge: 'Mencegah genangan air saat hujan deras dan memberikan tampilan lanskap modern yang aman untuk difabel.',
    solution: 'Kombinasi ThruCrete™ warna terracotta pada jalur sepeda dan DekoCrete™ exposed aggregate pada area pejalan kaki.',
    usedProducts: ['ThruCrete™', 'DekoCrete™'],
    gallery: [
      '/reference-images/project-gbk.webp'
    ]
  }
];

export const locations = [
  {
    id: 'plant-pulogadung',
    name: 'Batching Plant Pulogadung',
    type: 'Batching Plant',
    address: 'Jl. Jend. R.S. Soekanto No. 88, Kawasan Industri Pulogadung',
    city: 'Jakarta Timur',
    province: 'DKI Jakarta',
    lat: -6.1834,
    lng: 106.9125,
    phone: '(021) 460-3888',
    capacity: '120 m³/jam',
    status: 'Aktif 24 Jam'
  },
  {
    id: 'plant-serpong',
    name: 'Batching Plant Serpong',
    type: 'Batching Plant',
    address: 'Jl. Raya Serpong KM 7, Pakulonan, Serpong Utara',
    city: 'Tangerang Selatan',
    province: 'Banten',
    lat: -6.2512,
    lng: 106.6534,
    phone: '(021) 531-2999',
    capacity: '100 m³/jam',
    status: 'Aktif 24 Jam'
  },
  {
    id: 'plant-cikarang',
    name: 'Batching Plant Cikarang Dry Port',
    type: 'Batching Plant',
    address: 'Kawasan Industri Jababeka V, Harja Mekar',
    city: 'Bekasi',
    province: 'Jawa Barat',
    lat: -6.2915,
    lng: 107.1601,
    phone: '(021) 893-4112',
    capacity: '150 m³/jam',
    status: 'Aktif 24 Jam'
  },
  {
    id: 'plant-surabaya-margomulyo',
    name: 'Batching Plant Surabaya Margomulyo',
    type: 'Batching Plant',
    address: 'Jl. Margomulyo Industri No. 12, Tandes',
    city: 'Surabaya',
    province: 'Jawa Timur',
    lat: -7.2345,
    lng: 112.6789,
    phone: '(031) 749-5566',
    capacity: '120 m³/jam',
    status: 'Aktif 24 Jam'
  },
  {
    id: 'quarry-maloko',
    name: 'Tambang Agregat Maloko',
    type: 'Tambang Agregat',
    address: 'Jl. Raya Maloko, Rumpin',
    city: 'Bogor',
    province: 'Jawa Barat',
    lat: -6.3688,
    lng: 106.6123,
    phone: '(021) 879-1122',
    capacity: '2.500.000 ton/tahun',
    status: 'Tambang Resmi'
  },
  {
    id: 'head-office',
    name: 'Kantor Pusat Solusi Bangun Beton',
    type: 'Kantor Pusat',
    address: 'Gedung Menara BPPT II, Lt. 15, Jl. M.H. Thamrin No.8',
    city: 'Jakarta Pusat',
    province: 'DKI Jakarta',
    lat: -6.1821,
    lng: 106.8236,
    phone: '(021) 2986-1000',
    capacity: 'Corporate HQ',
    status: 'Operational Hours 08:00 - 17:00'
  }
];

export const certificates = [
  {
    id: 'cert-proper-biru',
    title: 'Penghargaan PROPER Biru KemenLHK',
    issuer: 'Kementerian Lingkungan Hidup dan Kehutanan RI',
    number: 'SK.1353/MENLHK/SETJEN/KUM.1/12/2023',
    year: '2023 - 2024',
    category: 'Lingkungan',
    summary: 'Sertifikasi atas pengelolaan lingkungan hidup yang taat aturan, pengendalian pencemaran air, udara, dan pengelolaan limbah B3.',
    fileUrl: '#pdf-proper-biru'
  },
  {
    id: 'cert-ekolabel-pulogadung',
    title: 'Sertifikat Ekolabel Swadeklarasi Beton Ramah Lingkungan',
    issuer: 'Kementerian Lingkungan Hidup / Lembaga Sertifikasi Ekolabel',
    number: 'EKO-SBB-2023-004',
    year: '2023 - 2026',
    category: 'Kualitas & Ekolabel',
    summary: 'Beton siap pakai SBB terbukti memanfaatkan bahan semen blended rendah karbon (Green Cement) serta air daur ulang.',
    fileUrl: '#pdf-ekolabel-pulogadung'
  },
  {
    id: 'cert-iso-9001',
    title: 'ISO 9001:2015 Sistem Manajemen Mutu',
    issuer: 'SUCOFINDO International Certification Services',
    number: 'QSC 01488',
    year: 'Berlaku s/d 2026',
    category: 'Sistem Manajemen',
    summary: 'Standar manajemen mutu internasional untuk proses produksi beton ready-mix, agregat, dan pengujian laboratorium.',
    fileUrl: '#pdf-iso-9001'
  },
  {
    id: 'cert-iso-14001',
    title: 'ISO 14001:2015 Sistem Manajemen Lingkungan',
    issuer: 'SUCOFINDO International Certification Services',
    number: 'EMS 00892',
    year: 'Berlaku s/d 2026',
    category: 'Sistem Manajemen',
    summary: 'Komitmen pengelolaan dampak lingkungan dalam setiap operasional batching plant dan fasilitas tambang.',
    fileUrl: '#pdf-iso-14001'
  },
  {
    id: 'cert-iso-45001',
    title: 'ISO 45001:2018 Sistem Manajemen K3',
    issuer: 'SUCOFINDO International Certification Services',
    number: 'OHS 00512',
    year: 'Berlaku s/d 2026',
    category: 'Keselamatan Kerja (K3)',
    summary: 'Jaminan perlindungan keselamatan dan kesehatan kerja terbaik bagi seluruh karyawan, armada, dan area proyek.',
    fileUrl: '#pdf-iso-45001'
  }
];

export const newsArticles = [
  {
    id: 'post-speedcrete-cisumdawu',
    slug: 'dukung-kelancaran-cisumdawu-speedcrete',
    title: 'Solusi Bangun Beton Terapkan Teknologi SpeedCrete™ pada Proyek Strategis Nasional',
    type: 'Siaran Pers',
    date: '14 Juli 2026',
    author: 'Tim Komunikasi Korporat SBB',
    category: 'Inovasi & Teknologi',
    image: '/reference-images/news-1.webp',
    excerpt: 'Teknologi beton cepat kering SpeedCrete™ berhasil menuntaskan pengecoran area perkerasan kritikal dalam waktu 6 jam tanpa mengganggu arus logistik.',
    content: `
      <p><strong>JAKARTA, 14 Juli 2026</strong> – PT Solusi Bangun Beton (SBB), anak perusahaan dari PT Solusi Bangun Indonesia Tbk dan bagian dari SIG, kembali menunjukkan kepemimpinannya dalam inovasi beton berteknologi tinggi. Melalui produk unggulannya, SpeedCrete™, SBB berhasil menyelesaikan perbaikan jalur utama infrastruktur tol dengan waktu pengeringan hanya 6 jam.</p>
      <p>Direktur Utama SBB menyatakan bahwa akselerasi proyek infrastruktur menuntut material yang tak hanya kuat tetapi juga efisien dalam penggunaan waktu. "Dengan SpeedCrete™, pembukaan jalan untuk lalu lintas dapat dilakukan di pagi hari setelah perbaikan overnight," jelasnya.</p>
      <p>Penggunaan material ramah lingkungan berbasis semen blended rendah karbon juga menjadi bukti komitmen sirkularitas sbb dalam setiap proyek nasional.</p>
    `
  },
  {
    id: 'post-perluasan-batching-plant',
    slug: 'perluasan-jaringan-batching-plant-2026',
    title: 'Solusi Bangun Beton Resmikan Batching Plant Baru di Kawasan Industri Cikarang Dry Port',
    type: 'Siaran Pers',
    date: '28 Mei 2026',
    author: 'Tim Komunikasi Korporat SBB',
    category: 'Operasional',
    image: '/reference-images/news-2.webp',
    excerpt: 'Fasilitas produksi beton teranyar berkapasitas 150 m³/jam ini dilengkapi sistem otomasi ramah lingkungan dan teknologi pengolahan limbah air daur ulang.',
    content: `
      <p><strong>BEKASI, 28 Mei 2026</strong> – Mengantisipasi lonjakan kebutuhan beton siap pakai untuk pembangunan kawasan industri dan logistik modern di Jawa Barat, PT Solusi Bangun Beton meresmikan Batching Plant Cikarang Dry Port.</p>
      <p>Plant ini mengadopsi teknologi wet-mix otomatis dengan filter debu tingkat tinggi yang mengurangi emisi particulate matter hingga 95%. Seluruh sisa saringan dan air sisa pencucian truk molen diproses kembali dalam unit recycling plant untuk mengeliminasi zero-waste outflow.</p>
    `
  },
  {
    id: 'post-artikel-beton-berpori',
    slug: 'solusi-pencegahan-banjir-beton-berpori-thrucrete',
    title: 'Memahami Cara Kerja ThruCrete™ dalam Mencegah Genangan Air Perkotaan',
    type: 'Artikel',
    date: '10 April 2026',
    author: 'Tim Engineering SBB',
    category: 'Edukasi Konstruksi',
    image: '/reference-images/news-3.webp',
    excerpt: 'Bagaimana material beton khusus ThruCrete™ mengalirkan air hujan kembali ke dalam tanah tanpa merusak daya dukung struktur.',
    content: `
      <p>Genangan air di area publik dan trotoar sering menjadi tantangan tahunan kota-kota besar di Indonesia. Penggunaan perkerasan konvensional kedap air memutus siklus infiltrasi alami air hujan ke dalam akuifer tanah.</p>
      <p>ThruCrete™ hadir sebagai jawaban teknologis. Dengan rongga udara terintegrasi sebesar 15%-25%, beton porus ini memiliki kemampuan meresapkan air hingga lebih dari 500 liter per meter persegi setiap menitnya.</p>
    `
  }
];

export const clients = [
  { id: 1, name: 'PT Wijaya Karya (Persero) Tbk', logoText: 'WIKA' },
  { id: 2, name: 'PT Adhi Karya (Persero) Tbk', logoText: 'ADHI KARYA' },
  { id: 3, name: 'PT Pembangunan Perumahan (Persero) Tbk', logoText: 'PT PP' },
  { id: 4, name: 'PT Waskita Karya (Persero) Tbk', logoText: 'WASKITA' },
  { id: 5, name: 'PT Hutama Karya (Persero)', logoText: 'HUTAMA KARYA' },
  { id: 6, name: 'PT Jaya Konstruksi MP Tbk', logoText: 'JAYA KONSTRUKSI' },
  { id: 7, name: 'Total Bangun Persada Tbk', logoText: 'TOTAL' },
  { id: 8, name: 'PT Obayashi Indonesia', logoText: 'OBAYASHI' }
];

export const sustainabilityPillars = [
  {
    title: 'Solusi Berkelanjutan (Sustainable Solutions)',
    desc: 'Pengembangan produk beton inovatif dengan jejak karbon 20–30% lebih rendah melalui formulasi Green Cement SIG dan pemanfaatan material alternatif terverifikasi.'
  },
  {
    title: 'Iklim, Ekonomi Sirkular, Air & Alam',
    desc: 'Penerapan sistem zero-liquid discharge pada batching plant, efisiensi konsumsi air baku melalui re-cycle air cuci mixer, serta konservasi lingkungan tambang agregat.'
  },
  {
    title: 'Karyawan & Komunitas Berdaya',
    desc: 'Menjamin standar Kesehatan & Keselamatan Kerja (K3) tanpa kompromi (Zero Harm) serta program pemberdayaan ekonomi masyarakat sekitar area operasional plant.'
  }
];
